import * as React from 'react'

import { Box, Icon, Tabs, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'
import i18n from 'modules/core/lib/i18n'
import { employeeUser } from 'modules/core/store/collections/users'

import employees from 'modules/employees/store/collections/employees'
import CycleSelector from 'modules/reviews/components/Analytics/CycleSelector'
import RawResults from 'modules/reviews/components/Analytics/RawResults'
import buildTabs from 'modules/reviews/components/Analytics/tabs'
import {
  ReviewAnalyticsProvider,
  useAnalytics,
} from 'modules/reviews/pages/performance/Show/Analytics/analyticsContext'
import type Review from 'modules/reviews/store/models/v2/Review'

import ScoreResults from './ScoreResults'

interface Props {
  form: Review
  employeeId: number
}

const Analytics = observer(({ form }: Props) => {
  const [tabs, setTabs] = React.useState(buildTabs())
  const { loading, analyticResults, setCycle, cycle } = useAnalytics()
  const formName = form.attributes.name

  return (
    <>
      <Box gap="s16" paddingBottom="s32" alignItems="flexStart">
        <Box>
          <Icon.Large icon="surveys" />
        </Box>
        <Text.Header2>{i18n.t('surveys.analytics.title')}</Text.Header2>
        <Text.Normal>{i18n.t('surveys.review.analytics.description')}</Text.Normal>
        {form.hasSchedule && !loading && (
          <CycleSelector analyticResults={analyticResults} cycle={cycle} setCycle={setCycle} />
        )}
      </Box>
      {loading && <Loading />}
      {!loading && (
        <Tabs
          currentId={tabs.find((tab) => tab.active)?.id ?? ''}
          onTabClicked={(tabId) => {
            setTabs(
              tabs.map((tab) => {
                if (tab.id === tabId) {
                  return {
                    ...tab,
                    active: true,
                  }
                }
                return {
                  ...tab,
                  active: false,
                }
              })
            )
          }}
        >
          {tabs.map((tab) => (
            <Tabs.Tab key={tab.id} id={tab.id} label={tab.label}>
              <Box paddingTop="s40">
                {tab.id === 'summary' && (
                  <ScoreResults formName={formName} analyticResults={analyticResults} />
                )}
                {tab.id === 'raw' && <RawResults formName={formName} />}
              </Box>
            </Tabs.Tab>
          ))}
        </Tabs>
      )}
    </>
  )
})

const WrappedAnalytics = (props: Props) => {
  const employee = employees.get(props.employeeId)
  const user = employee && employeeUser(employee)

  return (
    <ReviewAnalyticsProvider form={props.form} revieweeId={String(user?.attributes.id)}>
      <Analytics {...props} />
    </ReviewAnalyticsProvider>
  )
}

export default WrappedAnalytics
